import React, {useEffect, useState} from "react"
import {useHelp, useRoomParameters, useRoomSetup, useLocal} from "../AppContext"
import {layoutSidebarLeftWidth} from "../settings"
import {iconPlay} from "../Helper/Icons"
import {CtaBubble, CtaBubbleLabel} from "../Components/CtaBubble"
import {MenuLeft} from "../Components/MenuLeft"
import {SelectItem} from "../Components/Menu/SelectItem"
import {SelectNote} from "../Components/Menu/SelectNote"
import {interiorSort} from "../Helper/InteriorSort"
import style from "./Noise.css"

export const Noise = () => {
    const help = useHelp()
    const local = useLocal()

    useEffect(() => {
        help.setContext('laermquelle')
    }, [])

    return <>
        <MenuLeft label={"Lärmquelle"}>
            <CtaText/>
            <Noises/>
            <SelectNote/>
        </MenuLeft>
        <CtaBubble name={"noise"} left={layoutSidebarLeftWidth + 40} top={155}>
            <CtaBubbleLabel>
                {local.__("Lärmquelle")}
            </CtaBubbleLabel>
            <div dangerouslySetInnerHTML={{__html: local.__("Bitte wählen sie ihre Lärmquellen")}}/>
        </CtaBubble>
    </>
}

const CtaText = () => {
    const local = useLocal()
    return <div className={style.ctaText}>{local.__("Können Sie die bei Ihnen vorherschende Art des Lärms nächer bestimmen.")}</div>
}

const Noises = () => {
    const local = useLocal()
    const roomParameters = useRoomParameters()
    const roomSetup = useRoomSetup()
    const noiseOptions = interiorSort(local, roomParameters.getNoises(roomSetup.getType()))

    return <>
        {noiseOptions.map((noise, index) => {
            return <NoiseItem key={index} noise={noise}/>
        })}
    </>
}

const NoiseItem = ({noise}) => {
    const local = useLocal()
    const roomSetup = useRoomSetup()
    const [sample, setSample] = useState(null)

    const toggle = () => {
        roomSetup.toggleNoise(noise.code)
    }

    const play = event => {
        event.stopPropagation()
        if (sample) {
            sample.pause()
            setSample(null)
        } else {
            const audio = new Audio(noise.exampleSound)
            audio.play()
            setSample(audio)
        }
    }

    return <SelectItem isActive={roomSetup.hasNoise(noise.code)} onClick={toggle}>
        <div className={style.item}>
            <div>{local.getLabel(noise.name)}</div>
            <div>{local.getLabel(noise.description)}</div>
            <div className={style.sample} onClick={play}>
                <div className={sample ? style.stop : null}>{iconPlay}</div>
                <div>{local.__("Hörbeispiel")}</div>
            </div>
        </div>
    </SelectItem>
}